import { SlotGame } from "@nolimitcity/slot-game/bin/SlotGame";
import { FlowStateController } from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";

import { EventsManager, ReelsEvents } from "../../../abstracts/events/EventsManager";
import { AbstractFlowPresentation } from "../../../abstracts/flow/AbstractFlowStatePresentation";
import { AbstractGameMode } from "../../../abstracts/flow/AbstractGameMode";
import { DDD } from "../../DDD";
import DDDReel from "../../modules/Reels/DDDReel";
import { DDDXNudgeSymbol } from "../../modules/Reels/symbols/DDDXNudgeSymbol";

export class DDDRespinIdlePresentation extends AbstractFlowPresentation {
    protected DDDReels: DDDReel[];

    constructor(id: string = `DDDRespinIdlePresentation`) {
        super(id);
    }

    protected handleEvents() {
        super.handleEvents();

        EventsManager.on(ReelsEvents.GET_REELS, (reels: DDDReel[]) => {
            this.DDDReels = reels;
        });
    }

    protected finishController() {
        SlotGame.apiPlugin.betHandler.zeroBet();
        super.finishController();
    }

    public start(flowStateController: FlowStateController) {
        super.start(flowStateController);

        this.flowPresentationTimeline.resume();
    }

    protected override onRestoreStart(): void {
        super.onRestoreStart();
        this.restoreNudges();

        const isWinBeloWStake = DDD.model.isWinBelowStake(true);

        const isTotalWin = DDD.model.initData.mode === AbstractGameMode.RESPIN ? true : false;

        this.keypad.setWin(this.model.initData.accumulatedRoundWin, isTotalWin, isWinBeloWStake);
    }

    protected restoreNudges() {
        this.DDDReels.forEach((reel, reelIndex: number) => {
            if (DDD.model.initData.stickyXNudge[reelIndex]) {
                reel.isLocked = true;
                this.flowPresentationTimeline.add(
                    (reel.xNudgeSymbol as DDDXNudgeSymbol)!.restore(DDD.model.initData, reelIndex)
                );
            }
        });
        this.flowPresentationTimeline.progress(1);
    }
}
